module.exports = __webpack_public_path__ + "img/framework.b7c788a8.png";